import {
  ArrowLeft,
  ArrowRight,
  TableFooter,
  TablePagesContainer,
  TablePaginationContainer,
} from './styles/AXSTableFoot.styled';

interface AXSTableFootProps {
  handlePageChange: (page: number) => void;
  currentPage: number;
  totalPages: number;
}

export const AXSTableFoot = ({
  currentPage,
  handlePageChange,
  totalPages,
}: AXSTableFootProps) => {
  return (
    <TableFooter>
      <TablePaginationContainer>
        <ArrowLeft
          onClick={() => {
            if (currentPage > 1) {
              handlePageChange(currentPage - 1);
            }
          }}
        />
        <TablePagesContainer>
          {totalPages === 0 ? totalPages : currentPage} / {totalPages}
        </TablePagesContainer>
        <ArrowRight
          onClick={() => {
            if (currentPage < totalPages) {
              handlePageChange(currentPage + 1);
            }
          }}
        />
      </TablePaginationContainer>
    </TableFooter>
  );
};
